import { useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import Phone from 'services/Phone'
import SelectAsync from 'components/Inputs/SelectAsync'
import billValidator from 'validators/billValidator'
import MainButton from 'components/Buttons/MainButton'
import DateInput from 'components/Inputs/DateInput'
import submitOnEnter from 'utils/submitOnEnter'
import { DateTime } from 'luxon'
import { Formik } from 'formik'

import {
  Form,
  FormField,
  Row,
  Label,
  InfoText,
  WarningText,
  ErrorContainer
} from './styles'

export default function AddBillModal ({
  visible,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const getCustomers = async query => {
    try {
      const { data: customers } = await cutileiApi.get (
        `/businesses/${businessId}/customers?query=${encodeURIComponent (query)}`, requestConfig
      )

      return customers.data.map (customer => ({
        label: `${customer.name}${customer.phone && ` - ${Phone.formatPhone (customer.phone)}`}`,
        value: customer.id
      }))
    } catch (error) {
      logApiError (error)
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Nova comanda</DialogTitle>
        </DialogHeader>
        <Formik
          validationSchema={billValidator}
          initialValues={{
            'customer': null,
            'date': DateTime.now ().toFormat ('yyyy-MM-dd')
          }}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const { data: bill } = await cutileiApi.post ('/business_bills', {
                ...values,
                businessId,
                customerId: values.customer.value,
                value: 0
              }, requestConfig)

              setSubmitting (false)
              handleConfirm (bill)
              handleClose ()
            } catch (error) {
              setErrorMessage (getApiErrorMessage (error))
              setSubmitting (false)
              logApiError (error)
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit
          }) => {
            return (
              <>
                <DialogBody>
                  <Form onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
                    <Row>
                      <FormField style={{flex: 2}}>
                        <Label>Cliente</Label>
                        <SelectAsync
                          name='customer'
                          placeholder='Cliente...'
                          value={values.customer}
                          loadOptions={getCustomers}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          error={errors.customer}
                          touched={touched.customer}
                          onMenuOpen={() => setFieldValue ('customer', null)}
                        />
                        {touched.customer && errors.customer && (
                          <WarningText>
                            {errors.customer}
                          </WarningText>
                        )}
                      </FormField>
                      <FormField style={{flex: 1}}>
                        <Label>Data de abertura</Label>
                        <DateInput
                          placeholder='Data da comanda'
                          value={values.date}
                          onChange={date => setFieldValue('date', date)}
                          style={{width: '100%'}}
                        />
                        {touched.date && errors.date && (
                          <WarningText>
                            {errors.date}
                          </WarningText>
                        )}
                      </FormField>
                    </Row>
                    {errorMessage && (
                      <ErrorContainer>
                        <InfoText>{errorMessage}</InfoText>
                      </ErrorContainer>
                    )}
                  </Form>
                </DialogBody>
                <DialogFooter>
                  <MainButton
                    label='Abrir comanda'
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    width={180}
                  />
                </DialogFooter>
              </>
            )
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
